import { deactivateOrganisation } from '@infuse/api/iam/organisation';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { deactivateTenantOrganisation } from '@infuse/api/iam/tenant';
import { useGenericDeactivateOrganisation } from './generic/useGenericDeactivateOrganisation';

export const useDeactivateOrganisation = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericDeactivateOrganisation({
      apiFn: deactivateTenantOrganisation,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericDeactivateOrganisation({
    apiFn: deactivateOrganisation
  });
};
